import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getLocaisAtendimentoCategorias(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
            dados.pagina = 1;
            dados.quantidadePorPagina = 25;
        }
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("locaisAtendimentoCategorias/access/listar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getLocaisAtendimentoCategoriasPorNivel(context, $codigoCategoriaSuperior) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("locaisAtendimentoCategorias/access/listarPorNivel", {CODIGO_LOCAL_CATEGORIA_SUPERIOR: $codigoCategoriaSuperior}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },    
    getLocaisAtendimentoCategoriasBox(context, filtros) {
        filtros.componente = "SearchBoxLocaisAtendimentoCategorias";
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("locaisAtendimentoCategorias/access/listaBox", filtros).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getLocalAtendimentoCategoria(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("locaisAtendimentoCategorias/access/obter", {ID_LOCAL_CATEGORIA: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    deleteLocalAtendimentoCategoria(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("locaisAtendimentoCategorias/access/excluir", {ID_LOCAL_CATEGORIA: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    postLocalAtendimentoCategoria(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("locaisAtendimentoCategorias/access/salvar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};